import React from 'react';
import { videosPack } from '../assets/videosPack';
import { ASSET_TYPE } from '../react-three-components/sceneAsset';
import { STUDIO_ID_SUFFIX } from 'util/constants';
import styles from '../add-to-scene.module.css';

export default function VideoContent({ onAddToScene }) {
  const handleVideoClick = (video) => {
    onAddToScene({
      type: ASSET_TYPE.PRIMITIVE_TEXTURE.VIDEO_PLANE,
      url: video.url,
      name: video.name,
      previewImage: video.thumbnail,
      thumbnail: video.thumbnail,
      ref: React.createRef(),
    });
  };

  return (
    <div className={styles.gridContainer}>
      {videosPack.map((video, index) => (
        <div
          key={`${index}-${video.name}`}
          className={styles.libraryItem}
          onClick={() => handleVideoClick(video)}
        >
          <div className={styles.libraryThumbnail}>
            <img
              src={video.thumbnail}
              alt={video.name}
              className={styles.libraryThumbnailImg}
            />
          </div>

          <div className={styles.libraryItemName}>
            {video.name.replace(STUDIO_ID_SUFFIX, '')}
          </div>

          <button
            className={styles.addToSceneButton}
            onClick={(e) => {
              e.stopPropagation();
              handleVideoClick(video);
            }}
          >
            Add to scene
          </button>
        </div>
      ))}
    </div>
  );
}
